module.exports = __webpack_public_path__ + "static/media/lazienka-1-min.ca330409.png";